import React, {Component} from 'react';
import Table from "../../components/Table/Table";
import {hasUserRight, monthName, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import DetailedSearch from "../../components/DetailedSearch/DetailedSearch";
import NavBarKS from "../../components/NavBarKS";
import moment from "moment";
import TextOverFlowTooltip from "../../components/TextOverFlowTooltip";
import SquareButton from "../../components/SquareButton";
import SgkAppointmentXslModal from "./SgkAppointmentXslModal";
import {ACCESS_TOKEN, EntegratorConf} from "../../constants";
import {EntegratorIdentifiers, UserRightsEnum} from "../../helper/enums";
import SweetAlert from "react-bootstrap-sweetalert";
import Alert from "react-s-alert";

class SgkAppointmentList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			manual: false,
			content: [],
			total: 0,
			loading: false,
			searching: false,
			searchQuery: undefined,
			page: 0,
			size: 10,
			modal: false,
			disabledLoginBtn: false
		};
		this.fetchData = this.fetchData.bind(this);
		this.handleSearch = this.handleSearch.bind(this);
		this.impersonateByCustomerId = this.impersonateByCustomerId.bind(this);
		this.handleAssign = this.handleAssign.bind(this);
	}

	impersonateByCustomerId(row) {
		this.setState({disabledLoginBtn: true});
		let self = this;
		let recordId = row.recordId;
		let params = {
			url: '/user/impersonateCustomerId',
			method: "post",
			data: {
				customerId: recordId
			}
		};
		request(params)
			.then(function (response) {
				console.log(response)
				let data = response.data;
				localStorage.setItem(ACCESS_TOKEN, data.accessToken);
				self.props.onLogin();
				self.props.onImpersonate(true);
				self.setState({disabledLoginBtn: false});
			}).catch(function (error) {
			showAxiosError(error);
			self.setState({disabledLoginBtn: false});
		});
	}

	fetchData(accessor, direction, page, size) {
		let self = this;
		let sortStr = accessor !== undefined ? ('&sort=' + accessor + ',' + direction) : '&sort=appointmentTime,desc';
		let searchQuery = !self.state.searchQuery ? '' : '&' + self.state.searchQuery;
		let params = {
			url: '/sgkappointment/fetch?page=' + page + '&size=' + size + searchQuery + sortStr,
			method: "get",
		};
		self.setState({loading: true, searching: true, manual: self.manual === true ? false : self.manual});
		self.props.reload(true);
		request(params)
			.then(function (response) {
				self.setState({
					page: page,
					size: size,
					total: response.data.totalElements,
					content: response.data.content,
					loading: false,
					searching: false
				});
				console.log("content",response.data.content);
				self.props.reload(false);
			}).catch(function (error) {
			self.setState({loading: false, searching: false});
			self.props.reload(false);
			showAxiosError(error);
		});
	}

	handleSearch(searchQuery) {
		this.setState({
			searchQuery,
			searching: true
		}, () => this.fetchData(this.state.accessor, this.state.direction, 0, this.state.size))
	}

	showStatus(status){
	    let res = {
			"OPEN": {color:"#cd5c5c",label:"Atanmamış"},
			"ASSIGN": {color:"#4c80d0",label:"Atanmış"},
			"RECALL": {color:"#a57373",label:"Tekrar Aranacak"},
			"CLOSE": {color:"#5ccd5e",label:"Kapalı"}
		};
		return <span style={{color: res[status].color}}>{res[status].label}</span>;
	}

	handleAssign(row){
		let self = this;
		let params = {
			url: "/sgkappointment/assign",
			method: "post",
			data: row.recordId
		};
		request(params)
		.then(function (response) {
			Alert.success("Atama işlemi başarılı.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
			self.setState({alert:null})
			self.fetchData(
				self.state.accessor,
				self.state.direction,
				self.state.page,
				self.state.size,
			);
		}).catch(function (error) {
			showAxiosError(error);
		});
	}

	render() {
		const columns = [
			{
				accessor:[
					{Header: "VKN/TCKN", accessor: "customer.vknTckn"},
					{Header: "Müşteri Adı", accessor: "customer.customerName"}
				],
				sort:false,
				Cell: row => (<div>{row.customer.vknTckn}<br/><TextOverFlowTooltip text={row.customer.customerName} maxLength={32}/></div>)
			},
			{
				accessor:[
					{Header: "e-Posta", accessor: "email"},
					{Header: "Telefon", accessor: "phone"}
				],
				Cell: row => (<div>{row.email}<br/>{row.phone}</div>)
			},
			{
				accessor:[
					{Header: "Randevu Zamanı", accessor: "appointmentTime"},
					{Header: "Atanan Kullanıcı", accessor: "assignedUser"}
				],
				Cell: row => (<div>{moment(row.appointmentTime).isValid() ? moment(row.appointmentTime).format("DD-MM-YYYY HH:mm:ss") : ''}<br/>{row.assignedUser}</div>)
			},
			{
				accessor:[
					{Header: "Oluşturulma Zamanı", accessor: "createdAt"},
					{Header: "Güncellenme Zamanı", accessor: "updatedAt"}
				],
				Cell: (row) => (
					<div>
						{moment(row.createdAt).isValid() ? moment(row.createdAt).format("DD-MM-YYYY HH:mm:ss") : ''}<br/>
						{moment(row.updatedAt).isValid() ? moment(row.updatedAt).format("DD-MM-YYYY HH:mm:ss") : ''}
					</div>)
			},
			{
				accessor:[
					{Header: "Randevu Durumu", accessor: "statusMessage"},
					{Header: "Müşteri Açıklaması", accessor: "note"}
				],
				sort: false,
				Cell: row => (<div>{this.showStatus(row.statusMessage)}<br/>{<TextOverFlowTooltip text={row.note} maxLength={36}/>}</div>)
			},
			{
				Header: <div style={{textAlign: 'center'}}>İşlemler</div>,
				width: "10%",
				accessor: "",
				sortable: false,
				Cell: row => (<div>
					{hasUserRight(UserRightsEnum.entegratorSettings.accessCustomerPortal, this.props.currentUser) &&
						<button type="button"
								data-toggle="tooltip"
								data-placement="bottom"
								onClick={() => this.impersonateByCustomerId(row.customer)}
								title="Kullanıcı Portalına Git"
								style={{background: 'rgb(52, 216, 103)'}} rel="tooltip"
								className="Btn btn-icon">
							<i className="fa fa-desktop"/>
						</button>

					}
					{row.statusMessage === "OPEN" &&
						<button type="button"
							onClick={() => this.setState({
											alert: (
												<SweetAlert showCancel warning
													confirmBtnText="Evet"
													cancelBtnText="Hayır"
													confirmBtnBsStyle="danger"
													cancelBtnBsStyle="default"
													title="Emin misiniz?"
													onConfirm={() => {
														this.handleAssign(row)
													}}
													onCancel={() => this.setState({alert: null})}>
													Randevu size atanacak onaylıyor musunuz?
												</SweetAlert>
											)
								})}
							rel="tooltip"
							className="Btn btn-primary btn-sm btn-icon"
							style={{margin: "0px", background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}>
							<i className="fa fa-handshake-o"></i>
						</button>
					}
				</div>)
			}
		];

		const fields = [
			{
				label: "VKN/TCKN",
				accessor: "customer.vknTckn",
				type: "numericText",
				operator: "=",
			},
			{
				label: "Müşteri Adı",
				accessor: "customer.customerName",
				type: "text",
				operator: "=",
			},
			{
				label: "Durum Bilgisi",
				accessor: "statusMessage",
				type: "select",
				operator: "=",
				selectData: [
					{value: "", label: 'Tümü'},
					{value: "OPEN", label: 'Atanmamış'},
					{value: "ASSIGN", label: 'Atanmış'},
					{value: "RECALL", label: 'Tekrar Aranacak'},
					{value: "CLOSE", label: 'Kapalı'}
				]
			},
			{
				label: "Randevu Tarihi (Başlangıç)",
				accessor: "min_appointmentTime",
				type: "datetime",
				operator: ">=",
			},
			{
				label: "Randevu Tarihi (Bitiş)",
				accessor: "max_appointmentTime",
				type: "datetime",
				operator: "<=",
			}
		];

		return (
			<div className="row baseBackground">
				<NavBarKS offsetWidth={this.props.offsetWidth} innerWidth={window.innerWidth} name="sgkAppointmentList">
					{!((EntegratorIdentifiers.KOLAYSOFT === EntegratorConf.identifier ||
							EntegratorIdentifiers.SMART === EntegratorConf.identifier ||
							EntegratorIdentifiers.MBT === EntegratorConf.identifier) && (this.props.impersonateUserRoleId === 3 || this.props.impersonateUserRoleId === 4)) &&
						<SquareButton position="leftSide"
									  title="Randevu Listesini Excel'e Aktar"
									  onClick={() => this.setState({modal: true})}
									  img="excel-custom-transfer.png"
									  style={(this.props && this.props.currentUser && this.props.currentUser.entegrator) ? {} : {display: "none"}}
									  btnDisabled={false}/>}
				</NavBarKS>

				<div className="col-sm-12 satirBasi">
					<div className="card-header">
						<h4 className="card-title">Randevu Listesi</h4>
					</div>
					<div className="card-body">
						<div className="row">
							<div className="col-sm-12">
								<div className="" style={{marginTop: '10px', marginBottom: '10px'}}>
									<DetailedSearch fields={fields}
													loading={this.state.searching}
													onSearch={this.handleSearch}/>
								</div>
							</div>
						</div>
					</div>
					<div className="card-body">
						<div className=" row">
							<div className="col-sm-12">
								<Table columns={columns}
									   loading={this.state.loading}
									   loadingText="Kayıtlar getiriliyor..."
									   content={this.state.content}
									   total={this.state.total}
									   page={this.state.page}
									   manual={this.state.manual}
									   size={this.state.size}
									   options={["5", "10", "20", "50", "100"]}
									   fetchData={this.fetchData}
								/>
							</div>
						</div>
					</div>
				</div>
				{this.state.modal &&
				<SgkAppointmentXslModal
					modal={this.state.modal}
					title="Randevu Listesi Excel'e Aktarma"
					toggleModal={(flag) => this.setState({modal: flag})}/>
				}
				{this.state.alert}
			</div>
		);
	}
}

export default SgkAppointmentList;